import { Award, Linkedin } from "lucide-react";
import { toast } from "sonner";
import { generateCertificate } from "../../utils/generateCertificate";
import RatingWidget from "./RatingWidget";

export default function CelebrationModal({ onClose, user }) {
  const handleDownload = () => {
    const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    generateCertificate(user?.name || user?.email || "Valued Customer", date);
    toast.success("Certificate downloaded!", { duration: 2000 });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        data-testid="celebration-modal"
        className="max-h-[92vh] w-full max-w-md overflow-y-auto rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-8 shadow-[6px_6px_0px_var(--c-shadow)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full border-2 border-[#A3E6D5] bg-[#A3E6D5]/20 shadow-[3px_3px_0px_var(--c-shadow)]">
            <Award className="h-8 w-8 text-[#1E3A8A]" />
          </div>
          <h2 className="font-heading text-3xl font-black text-[var(--c-text)]">
            Congratulations!
          </h2>
          <p className="mt-3 text-[var(--c-muted)]">
            You&apos;ve completed all 9 steps of the Texas LLC Formation Guide. Your dedication to building your business the right way is commendable.
          </p>

          <div className="my-6 rounded-xl border-2 border-[#A3E6D5] bg-[#A3E6D5]/10 p-5">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--c-muted)]">Achievement Unlocked</p>
            <p className="mt-1 font-heading text-lg font-bold text-[var(--c-text)]">LLC Formation Complete</p>
            <p className="mt-1 text-sm text-[var(--c-muted)]">All 35 checklist items completed</p>
          </div>

          <button
            data-testid="download-certificate-button"
            onClick={handleDownload}
            className="flex w-full items-center justify-center gap-2 rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-6 py-3.5 font-bold text-white shadow-[4px_4px_0px_var(--c-shadow)] transition-all hover:-translate-y-1 hover:shadow-[6px_6px_0px_var(--c-shadow)]"
          >
            <Award className="h-5 w-5" />
            Download Certificate
          </button>

          <a
            data-testid="share-linkedin-button"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.origin)}&title=${encodeURIComponent("I just completed the Texas LLC Formation Guide!")}&summary=${encodeURIComponent("All 9 steps done — from choosing an LLC name to staying compliant. Ready to launch my business!")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-full border-2 border-[#0A66C2] bg-[#0A66C2]/10 px-6 py-3 font-bold text-[#0A66C2] transition-all hover:-translate-y-0.5 hover:bg-[#0A66C2]/20 hover:shadow-[3px_3px_0px_var(--c-shadow)]"
          >
            <Linkedin className="h-5 w-5" />
            Share on LinkedIn
          </a>

          <RatingWidget />

          <button
            onClick={onClose}
            className="mt-4 text-sm font-medium text-[var(--c-muted)] hover:text-[var(--c-text)]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
